import { useWebTranslation, Trans } from "translations";
import { Icon } from "ui-kit";
import {
  CHAT_MESSAGE_DISPLAY_NAME,
  MessageTransition,
} from "ui-kit/ChatMessage/ChatMessage";
import Colors from "ui-kit/colors";
import { Typography } from "ui-kit/Typography";
import styles from "./MultipetDisclaimer.module.css";

export const MultipetDisclaimer = ({
  index,
  transitioning,
}: {
  index?: number;
  transitioning?: boolean;
}) => {
  const { t } = useWebTranslation();

  return (
    <MessageTransition
      fromMe={false}
      transitioning={transitioning}
      index={index}
      className={styles.container}
    >
      <div className={styles.header}>
        <Icon name="discount-badge" color={Colors.blue300} ariaHidden />
        <strong>{t("signup.multipet_info.title")}</strong>
      </div>

      <Typography variant="body2" color="grey500">
        <Trans
          i18nKey={"signup.multipet_info.description"}
          components={[<strong key="0" />, <strong key="1" />]}
        />
      </Typography>
    </MessageTransition>
  );
};

MultipetDisclaimer.displayName = CHAT_MESSAGE_DISPLAY_NAME;
